import { render, staticRenderFns } from "./RelativeTime.vue?vue&type=template&id=2d66cb62"
import script from "./RelativeTime.vue?vue&type=script&lang=js"
export * from "./RelativeTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports